module.exports = __webpack_public_path__ + "static/media/icon-enable2fa-phone.04c6a6b6.svg";